/**
 * Class for debug console
 */
var Log = /** @class */ (function () {
    function Log() {
    }
    /**
     * console.log
     */
    Log.log = function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            message[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV !== 'production') {
            console.log.apply(console, message);
        }
    };
    /**
     * console.info
     */
    Log.info = function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            message[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV !== 'production') {
            console.info.apply(console, arguments);
        }
    };
    /**
     * console.warn
     */
    Log.warn = function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            message[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV !== 'production') {
            console.warn.apply(console, arguments);
        }
    };
    /**
     * console.error
     */
    Log.error = function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            message[_i] = arguments[_i];
        }
        if (process.env.NODE_ENV !== 'production') {
            console.error.apply(console, arguments);
        }
    };
    return Log;
}());
export default Log;
